import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '../contexts/AuthContext';
import Layout from '../components/Layout';
import Dashboard from './Dashboard';
import Users from './Users';
import Trips from './Trips';
import Requests from './Requests';
import Transactions from './Transactions';
import Fees from './Fees';
import Messages from './Messages';
import Verifications from './Verifications';
import DriverVerifications from './DriverVerifications';
import Support from './Support';
import Login from './Login';
import Unauthorized from './Unauthorized';

function AppContent() {
  const { user, loading, isAdmin, userData } = useAuth() as {
    user: any;
    loading: boolean;
    isAdmin: boolean;
    userData: any;
  };

  // Debug logging
  console.log('AdminApp - Auth State:', {
    hasUser: !!user,
    userId: user?.uid,
    loading,
    isAdmin,
    userData: userData ? {
      role: userData.role,
      isAdmin: userData.isAdmin,
      roles: userData.roles,
    } : null,
  });

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/unauthorized" element={<Unauthorized />} />
      <Route
        path="/login"
        element={
          !user ? (
            <Login />
          ) : isAdmin ? (
            <Navigate to="/admin" replace />
          ) : (
            <Navigate to="/admin/unauthorized" replace />
          )
        }
      />
      <Route
        path="/"
        element={
          !user ? (
            <Navigate to="/admin/login" replace />
          ) : !isAdmin ? (
            <Navigate to="/admin/unauthorized" replace />
          ) : (
            <Layout />
          )
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="trips" element={<Trips />} />
        <Route path="requests" element={<Requests />} />
        <Route path="transactions" element={<Transactions />} />
        <Route path="fees" element={<Fees />} />
        <Route path="messages" element={<Messages />} />
        <Route path="support" element={<Support />} />
        <Route path="verifications" element={<Verifications />} />
        <Route path="driver-verifications" element={<DriverVerifications />} />
      </Route>
    </Routes>
  );
}

function AdminApp() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default AdminApp;

